export default "__VITE_ASSET__DHI02NaB__"